import { useContext } from 'react';
import SeedProductsContext from './SeedProductsContext';

const useSeedProducts = () => {
  return useContext(SeedProductsContext);
};

export default useSeedProducts;
